export default __webpack_public_path__ + "static/media/a8.6aa31e92.png";